<template>
  <div>
    <v-layout v-if="refresh" justify-end align-center class="pa-3">
      <v-btn
        class="text-capitalize"
        color="primary"
        small
        text
        @click="onRefreshClicked"
      >
        <v-icon left> mdi-refresh </v-icon>
        Refresh
      </v-btn>
    </v-layout>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="tableOptions"
      :server-items-length="totalItemCount"
      :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-layout v-if="hasActions" justify-end>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <v-icon class="ma-0">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <template v-for="(action, index) of actions">
                <template v-if="isAction(action)">
                  <v-list-item
                    v-if="action.hidden ? !action.hidden(item) : true"
                    :key="index"
                    @click="action.click ? action.click(item) : undefined"
                  >
                    <v-list-item-icon v-if="action.icon"
                      ><v-icon>mdi-{{ action.icon }}</v-icon></v-list-item-icon
                    >
                    <v-list-item-title>{{ action.label }}</v-list-item-title>
                  </v-list-item>
                </template>
                <v-divider v-if="isSeparator(action)" :key="index" />
              </template>
            </v-list>
          </v-menu>
        </v-layout>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import strings, { SyntaxCase } from "../../../utils/strings";

export default {
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    hideColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    showColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    refresh: {
      type: Boolean,
      required: false,
      default: true,
    },
    totalItemCount: {
      type: Number,
      required: false,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  }, // props

  data() {
    return {
      tableOptions: {},
      lastPageIndex: 0,
      lastPageSize: 10,
    };
  }, // data
  mounted() {}, // mounted

  computed: {
    headers() {
      if (
        this.hideColumns != null &&
        this.hideColumns.length > 0 &&
        this.showColumns != null &&
        this.showColumns.length > 0
      )
        throw new Error(
          "Cannot hide and show columns. Only one at a time is supported"
        );

      /** @type {Array} */

      let columns = this.items.length > 0 ? Object.keys(this.items[0]) : [];

      if (this.hideColumns != null && this.hideColumns.length > 0)
        columns = columns.filter(
          (key) => !this.hideColumns.some((col) => col == key)
        );
      else if (this.showColumns != null && this.showColumns.length > 0)
        columns = this.showColumns;

      return [
        ...columns.map((column) => {
          let columnText = "";

          if (column.includes(".")) {
            const parts = column.split(".");
            const normalizedParts = parts.map((str) =>
              strings.changeSyntax(
                str,
                SyntaxCase.camelCase,
                SyntaxCase.humanCase
              )
            );
            const normalizedPartsStr = normalizedParts.join(" ");
            const uniqueParts = Array.from(
              new Set(normalizedPartsStr.split(" "))
            );
            columnText = uniqueParts.join(" ");
          } else {
            columnText = strings.changeSyntax(
              column,
              SyntaxCase.camelCase,
              SyntaxCase.humanCase
            );
          }

          return {
            text: columnText,
            value: column,
          };
        }),
        {
          text: "",
          value: "actions",
        },
      ];
    },
    hasActions() {
      return this.actions != null && this.actions.length > 0;
    },
  }, // computed

  methods: {
    onRefreshClicked() {
      this.$emit("refresh");
    },
    isAction(item) {
      return item.separator != true;
    },
    isSeparator(item) {
      return item.separator == true;
    },
  }, // methods

  watch: {
    tableOptions() {
      const pageIndex = this.tableOptions.page - 1;
      const pageSize = this.tableOptions.itemsPerPage;
      this.$emit("paginationChanged", { pageIndex, pageSize });
    },
  }, // watch
};
</script>
